module.exports = __webpack_public_path__ + "img/中雨.79812159.png";